module.exports = __webpack_public_path__ + "img/titleen.21181c49.png";